module.exports = __webpack_public_path__ + "static/media/gym2.884c771c.jpg";